export default function HomeSection() {
  return (
    <>
      <section id="home">
        <div className="forcefullwidth_wrapper_tp_banner home_full_width_banner position-relative">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6" />
              <div className="col-md-12">
                {/* <img
                  className="wow fadeInRight"
                  data-wow-duration="1.5s"
                  data-wow-offset="1"
                  src={ResultPng}
                  width="100%"
                  alt="Navira Live - RajKumar"
                /> */}
              </div>
              <div className="col-md-1" />
            </div>
          </div>
          <div className="banner_lines">
            <div className="container">
              <div className="row">
                <div
                  className="col-md-12 wow fadeInLeft"
                  data-wow-duration="1.5s"
                  data-wow-offset="10"
                >
                  <h1 className="mt-70 sm-mt-30px">Welcome to Navira Live</h1>
                  <p className="text-white">
                    At Navira Live is a new age Live that focuses on helping your child score high
                    in competitive exams while also offering conceptual understanding of the
                    subjects.
                  </p>
                  <a href="" className="firo-bottom black_bg_btn sm mt-20">
                    Read More
                  </a>
                </div>
                <div className="col-md-6" />
              </div>
            </div>
          </div>
          {/* <div className="banner_wave_1">
            <div className="container">
              <div className="row">
                <img src={WaveImg} width="100%" alt="Neet Live- RajKumar" />
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}
